module.exports = __webpack_public_path__ + "media/assets/images/flags/lu-c5ef45155959ea80834edf95531d4ef0.svg";